import React from "react";
import type { FoodSpot } from "../types";
import SpotCard from "./SpotCard";

interface Props {
  spots: FoodSpot[];
  onSelect: (spot: FoodSpot) => void;
  onClear: () => void;
}

const SpotList: React.FC<Props> = ({ spots, onSelect, onClear }) => {
  if (spots.length === 0) {
    return (
      <div className="empty-state">
        <i className="fa-solid fa-bowl-rice" aria-hidden="true" />
        <h3>No spots match your filters</h3>
        <p>Try removing a filter or searching for something broader.</p>
        <button onClick={onClear}>Clear all filters</button>
      </div>
    );
  }

  return (
    <div className="spot-grid">
      {spots.map((spot) => (
        <SpotCard key={spot.id} spot={spot} onSelect={onSelect} />
      ))}
    </div>
  );
};

export default SpotList;